import React from 'react';
import { Modal, Button } from 'antd';
import { useNavigate } from 'react-router-dom';

const MapModal = ({ visible, onCancel, markerData }) => {

    const navigate = useNavigate();
    const details = markerData?.type === 'breakdown'
        ? {
            breakdownReference: markerData?.breakdownReference?.trim() || 'N/A',
            breakdownAddress: markerData?.breakdownAddress?.trim() || 'N/A',
            registrationNumber: markerData?.registrationNumber?.trim() || 'N/A',
            companyName:
                markerData?.customerName?.trim() ||
                markerData?.companyName?.trim() ||
                'N/A',
            fleetNumber: markerData?.fleetNumber?.trim() || 'N/A',
            vinNumber: markerData?.vinNumber?.trim() || 'N/A',
            make: markerData?.make?.trim() || 'N/A',
            model: markerData?.model?.trim() || 'N/A',
            year: markerData?.year?.toString().trim() || 'N/A',
            description: markerData?.description?.trim() || 'N/A',
        }
        : {
            firstName: markerData?.firstName?.trim() || 'N/A',
            mobileNumber: markerData?.mobileNumber?.trim() || 'N/A',
            companyName:
                markerData?.customerName?.trim() ||
                markerData?.companyName?.trim() ||
                'N/A',
        };

    const handleViewBreakdown = () => {
        const breakdownId = markerData.id ?? markerData.breakdownId;
        navigate(`/breakdown/${breakdownId}`);
    };

    return (
        <Modal
            title={markerData?.type === 'breakdown' ? "Breakdown Details" : "Mechanic Details"}
            open={visible}
            onCancel={onCancel}
            footer={null}
        >
            <div style={{ padding: '20px' }}>
                <h1 style={{ fontSize: '24px', marginBottom: '20px' }}> {markerData?.type === 'breakdown' ? details.breakdownReference : details.companyName}</h1>

                {markerData?.type === 'breakdown' ? <div style={{ marginTop: '10px' }}>
                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Company Name:</span> {details.companyName}</p>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Address:</span> {details.breakdownAddress}</p>


                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Registration Number:</span> {details.registrationNumber}</p>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Fleet Number:</span> {details.fleetNumber}</p>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>VIN Number:</span> {details.vinNumber}</p>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Make:</span> {details.make}</p>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Model:</span> {details.model}</p>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Year:</span> {details.year}</p>


                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Description:</span> {details.description}</p>


                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                        <Button style={{ width: '100%' }} type="primary" onClick={handleViewBreakdown}>View Breakdown</Button>
                    </div>
                </div> : <div style={{ marginTop: '10px' }}>

                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Full Name:</span> {details.firstName}</p>


                    <p style={{ marginBottom: '10px' }}><span style={{ fontWeight: 'bold' }}>Mobile Number:</span> {details.mobileNumber}</p>

                </div>}

            </div>
        </Modal>
    );
};

export default MapModal;